import { Component, OnInit } from '@angular/core';
import { FormGroup, Form, FormControl, Validators } from '@angular/forms';
import { state } from '@angular/animations';
import { DoctorsService } from 'src/app/shared/doctor-service/doctors.service';
import { SelectItem } from 'primeng/api/selectitem';
import { AuthService } from 'src/app/auth-section/auth-service/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-docreg',
  templateUrl: './docreg.component.html',
  styleUrls: ['./docreg.component.css']
})
export class DocregComponent implements OnInit {

  count=1
  rgForm:FormGroup;
  piForm:FormGroup;
  di:Form;
  CouncilArray=[]

  ci:Form;
  doctorTypeAray=[]
  degrees: SelectItem[]
  clinicDays:SelectItem[]
  isDocType=false;
  countryArray= [];
  isCbDisabled=true;
  isSelectDefaultOption: boolean=false;

  constructor(private docService:DoctorsService,private authService:AuthService,private router:Router) {

  }

  ngOnInit(): void {
    this.degrees = [
      {label:'MBBS', value:{ name:'MBBS'}},
      {label:'BDS', value:{name: 'BDS'}},
      {label:'MD', value:{name: 'MD'}},
      {label:'BSC Nursing', value:{name: 'BSC Nursing'}},
      {label:'B.Pharmacy', value:{name: 'B.Pharmacy'}}
  ];
  this.clinicDays = [
    {label:'Sunday', value:{ name:'Sunday'}},
    {label:'Monday', value:{name: 'Monday'}},
    {label:'Tuesday', value:{name: 'Tuesday'}},
    {label:'Wednesday', value:{name: 'Wednesday'}},
    {label:'Thursday', value:{name: 'Thursday'}},
    {label:'Friday', value:{name: 'Friday'}},

    {label:'Saturday', value:{name: 'Saturday'}}

];

    this.getDoctorType()
this.getMedicalCouncil()
    this.initRgForm()
  }
  onPageNext() {
  /*  const name = this.rgForm.value["name"];
    const doctorType = this.rgForm.value["doctorType"];
    const email = this.rgForm.value["email"];
    const password = this.rgForm.value["password"];
   const degree = this.rgForm.value["degree"];

    const line1 = this.rgForm.value["line1"];
    const city = this.rgForm.value["city"];
    const pincode = this.rgForm.value["pincode"];
    const state = this.rgForm.value["state"];

    const clinic = this.rgForm.value["clinic"]
    const phoneNo = this.rgForm.value["phoneNo"];*/
    if(this.count<5){

        this.count = this.count + 1;


    }
  }
  onPreviousPage() {
    if(this.count>1){
    this.count = this.count - 1;
    }
  }
  initRgForm() {
    this.rgForm=new FormGroup({
    name: new FormControl(null, Validators.required),
   doctorType: new FormControl(null, Validators.required),
    email: new FormControl(null, [Validators.required, Validators.email]),
    password: new FormControl(null, Validators.required),
    degree: new FormControl(null, Validators.required),
  //  gender: new FormControl(null, Validators.required),

line1: new FormControl(null, Validators.required),
city: new FormControl(null, Validators.required),
pincode: new FormControl(null, [
     Validators.required,
     Validators.pattern(/^-?(0|[1-9]\d*)?$/)
    ]),
   state: new FormControl(null),
   experience: new FormControl(null, [Validators.required, Validators.pattern(/^-?(0|[1-9]\d*)?$/),
  ]),
   memberCouncil: new FormControl(null, Validators.required),
   memberCouncilId: new FormControl(null,Validators.required),
   patientLimit: new FormControl(null, Validators.required),
   consFee: new FormControl(null, Validators.required),
   clinicDays: new FormControl(null,Validators.required),

    clinic: new FormControl(null, Validators.required),
   phoneNo: new FormControl(null, [
      Validators.required,
      Validators.pattern(/^-?(0|[1-9]\d*)?$/),
      Validators.maxLength(10),
      Validators.minLength(10)
    ])
  });
  }

  getDoctorType(){
    this.docService.getDocType("").subscribe(res=>{
      this.doctorTypeAray=res
this.isDocType=true
    })
  }
  getMedicalCouncil(){
    this.docService.getCouncilCountry().subscribe(res=>{
      this.countryArray=res.council
    })
  }
  onChangeCountry(con){
   this.CouncilArray=[]
   this.isSelectDefaultOption=true
    this.isCbDisabled=true
    this.docService.getCouncilByCountry(con).subscribe(res=>{
this.CouncilArray=res.council.councilName
this.isCbDisabled=false
    })
  }
  get f (){
    return this.rgForm.controls;
  }
  onSubmit(){
 
    
    const name = this.rgForm.value["name"];
    const doctorType = this.rgForm.value["doctorType"];
    const email = this.rgForm.value["email"];
    const password = this.rgForm.value["password"];
    let degree = this.rgForm.value["degree"];

    const line1 = this.rgForm.value["line1"];
    const city = this.rgForm.value["city"];
    const pincode = this.rgForm.value["pincode"];
    const state = this.rgForm.value["state"];

    const clinic = this.rgForm.value["clinic"];
    const phoneNo = this.rgForm.value["phoneNo"];
    const experience = this.rgForm.value["experience"];
    const memberCouncil = this.rgForm.value["memberCouncil"];
    const patientLimit = this.rgForm.value["patientLimit"];
   const memberCouncilId= this.rgForm.value["memberCouncilId"];
    const consFee = this.rgForm.value["consFee"];
    let clinicDays = this.rgForm.value["clinicDays"];
    console.log(this.rgForm.valid)

    degree=degree.map(sin=>{
      return sin.name
    })
    clinicDays=clinicDays.map(sin=>{
      return sin.name
    })

this.authService.RegisterDoctorToDatabase(name,doctorType,email,experience,degree,line1,city,pincode,
  state,memberCouncil,patientLimit,consFee,clinicDays,clinic,phoneNo,password,memberCouncilId).subscribe(res=>{
this.count= this.count+1
this.router.navigate(['/auth'])

  })

  }
}
